import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48f023a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "diy-flex diy-ul"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "diy-flex" }
const _hoisted_5 = { class: "diy-flex" }

import { deepClone, ViewType } from '@kunlun/dependencies';
import {
    OioSpin,
    OioButton,
    OioInput,
    OioModal,
    OioSelect,
    OioRow,
    OioCol,
    OioSwitch,
    OioForm,
    OioFormItem,
    OioNotification
} from '@kunlun/vue-ui-antd';
import { computed, onMounted, reactive, ref, watch } from 'vue';


// 定义 props 类型并设置默认值
interface IProps {
    value: string;
    change: (val: any) => void;
}

interface listDataType {
    prefix: string; // 前缀
    suffix: string; // 后缀
    ttype: "String" | "Select" | 'Radio';
    fieldBind: string; // 绑定字段
    OptionEnum: string; // 字典枚举
    placeholder: string; //提示文字,
    defaultValue: string;
    sign: string;
    disabled: boolean;
}

interface viewDataType {
    title?: string;
    field?: string;
    listData: Array<listDataType>| undefined;
    valueType: ValueType
}

interface loadingState {
    dataLoading: boolean;
    addLoading: boolean;
    submitLoading: boolean;
}
interface ttypeOptionsType {
    label: string;
    value: "String" | "Select" | 'Radio';
}
enum ValueType {
    Object = 'Object',
    Arrry = 'Arrry',
}





export default /*#__PURE__*/_defineComponent({
  __name: 'StringPropertiesPanel',
  props: {
    value: { default: '' },
    change: { type: Function, default: () => { } }
  },
  setup(__props: any) {

const props = __props as { value: string, change: (val: any) => void }



// 定义数据类型
const valueTypeOptions = [
    {
        label: '对象',
        value: ValueType.Object
    },
    {
        label: '数组',
        value: ValueType.Arrry
    },
]
const configFrom = reactive<listDataType>({
    prefix: '',
    suffix: '',
    ttype: 'String',
    placeholder: '请输入',
    disabled: false,
    OptionEnum: '',
    defaultValue: '',
    sign: '',
    fieldBind: ''
})
// 初始化加载状态
const loading = reactive<loadingState>({
    dataLoading: false,
    addLoading: false,
    submitLoading: false
});
//控制弹窗显示与隐藏
const showConfig = ref<boolean>(false);
// 初始化视图数据
const viewData = reactive<viewDataType>({
    title: '',
    field: '',
    valueType: ValueType.Object,
    listData: undefined,
});
// 组件类型
const ttypeOptions = reactive<ttypeOptionsType[]>([
    {
        label: '输入框',
        value: 'String'
    },
    {
        label: '下拉单选',
        value: 'Select',
    },
    {
        label: '单选',
        value: 'Radio',
    }
])

// 控制加载状态
const controlLoading = (state: boolean, key?: keyof loadingState) => {
    if (key) {
        loading[key] = state;
    } else {
        Object.keys(loading).forEach(k => (loading[k as keyof loadingState] = state));
    }
};
const createdComData: listDataType = {
    prefix: '',
    suffix: '',
    ttype: 'String',
    placeholder: '请输入',
    disabled: false,
    OptionEnum: '',
    defaultValue: '',
    sign: '',
    fieldBind: ''
}
// 添加组件
const addCurrentTools = (): void => {
    if (viewData.listData === undefined) {
        viewData.listData = []
    }
    Object.assign(configFrom, createdComData);
    openModel(true);;
};
const isUpData = ref<boolean>(false)
const upDataRow = ref<number | undefined>(undefined);
//组件配置弹窗
const openModel = (state: boolean, upData?: boolean, upDataIndex?: number): void => {
    isUpData.value = !!upData
    upDataRow.value = upDataIndex
    if (isUpData.value && typeof (upDataRow.value) === 'number' && viewData.listData?.length) {
        Object.assign(configFrom, viewData.listData[upDataRow.value]);
    }
    showConfig.value = state;
}
//修改值类型
const changeValueType = (e) => {
    viewData.valueType = e
    viewData.title = ''
    viewData.field = ''
    viewData.listData = undefined
    props.change(JSON.stringify(viewData))
}
// 删除当前组件
const delItem = (index: number): void => {
    //@ts-ignore
    viewData.listData!.splice(index, 1);
};

// 更新当前视图数据
const viewDataChanged = (): void => {
    controlLoading(true, 'submitLoading');
    props.change(JSON.stringify(viewData));
    controlLoading(false, 'submitLoading');
};
const add = () => {
    controlLoading(true, 'addLoading');
    if (viewData.valueType === ValueType.Arrry && !configFrom.sign) {
        return OioNotification.error('请输入标识')
    }
    const currentFromData = deepClone(configFrom)
    if (!viewData.listData) {
        viewData.listData = []
    }
    if (isUpData.value && typeof (upDataRow.value) === 'number') {
        //@ts-ignore
        viewData.listData![upDataRow.value] = currentFromData
    } else {
        //@ts-ignore
        viewData.listData!.push(currentFromData);
    }
    openModel(false);
    // 执行添加操作
    controlLoading(false, 'addLoading');
}
//选择组件类型
const changeTtype = (e: any): void => {
    configFrom.ttype = e;
    if (e === 'Select') {
        configFrom.placeholder = "请选择"
    }
    if (e === 'String') {
        configFrom.placeholder = "请输入"
    }
}
watch(() => props.value, (val) => {
    if (props.value && val !== "请选择" && val !== '逾期记录' && val !== '配送车辆') {
        Object.assign(viewData, JSON.parse(val))
    }
}, {
    deep: true,
    immediate: true
})

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(OioSpin), {
      loading: loading.dataLoading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createTextVNode("组件值类型（变更会清除组件数据）： "),
          _createVNode(_component_a_select, {
            class: "oio-select component-select",
            style: {"width":"120px"},
            onChange: changeValueType,
            "dropdown-class-name": "oio-select-dropdown",
            value: viewData.valueType,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((viewData.valueType) = $event)),
            options: valueTypeOptions,
            placeholder: "请选择组件值类型"
          }, null, 8, ["value"])
        ]),
        (ValueType.Arrry === viewData.valueType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, " 组件值为Array时标识相同视为同一组 "))
          : _createCommentVNode("", true),
        (viewData?.listData?.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(viewData?.listData, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "diy-li",
                  key: index
                }, [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(index + 1 + "、" + item?.fieldBind) + "组件", 1),
                    (viewData.valueType === ValueType.Arrry)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "，标识" + _toDisplayString(item.sign), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(OioButton), {
                      type: "primary",
                      onClick: ($event: any) => (openModel(true, true, index))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("配置")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_unref(OioButton), {
                      type: "primary",
                      onClick: ($event: any) => (delItem(index))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: addCurrentTools
          }, {
            default: _withCtx(() => [
              _createTextVNode("添加组件")
            ]),
            _: 1
          }),
          _createVNode(_unref(OioButton), {
            type: "primary",
            onClick: viewDataChanged
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交修改")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_unref(OioModal), {
      width: "60%",
      visible: showConfig.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((showConfig).value = $event)),
      title: "配置组件"
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), {
          onClick: add,
          type: "primary"
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(OioForm), {
          data: configFrom,
          class: "OioFormStyle",
          "label-col": { span: 12 },
          "wrapper-col": { span: 12 }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(OioRow), { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "前缀" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: configFrom.prefix,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((configFrom.prefix) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "后缀" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: configFrom.suffix,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((configFrom.suffix) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "组件类型" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          class: "oio-select",
                          "dropdown-class-name": "oio-select-dropdown",
                          value: configFrom.ttype,
                          onChange: changeTtype,
                          options: ttypeOptions
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (configFrom.ttype !== 'Radio')
                  ? (_openBlock(), _createBlock(_unref(OioCol), {
                      key: 0,
                      span: 6
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioFormItem), { label: "提示文字" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(OioInput), {
                              value: configFrom.placeholder,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((configFrom.placeholder) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(OioRow), { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "组件绑定字段" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: configFrom.fieldBind,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((configFrom.fieldBind) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (configFrom.ttype != 'String')
                  ? (_openBlock(), _createBlock(_unref(OioCol), {
                      key: 0,
                      span: 6
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioFormItem), { label: "字典枚举" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(OioInput), {
                              value: configFrom.OptionEnum,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((configFrom.OptionEnum) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "组件默认值" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioInput), {
                          value: configFrom.defaultValue,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((configFrom.defaultValue) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (viewData.valueType === ValueType.Arrry)
                  ? (_openBlock(), _createBlock(_unref(OioCol), {
                      key: 1,
                      span: 6
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioFormItem), { label: "标识" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(OioInput), {
                              value: configFrom.sign,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((configFrom.sign) = $event))
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_unref(OioRow), { type: "flex" }, {
              default: _withCtx(() => [
                _createVNode(_unref(OioCol), { span: 6 }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(OioFormItem), { label: "是否禁用" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(OioSwitch), {
                          checked: configFrom.disabled,
                          "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((configFrom.disabled) = $event))
                        }, null, 8, ["checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})